import { Component } from '@angular/core';
import * as moment from 'moment';

moment.updateLocale('en', {
    weekdaysMin: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
});
moment.updateLocale('fr', {
    weekdaysMin: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
});

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
})
export class AppComponent {}
